import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextStrikethrough = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 9.99968C11.8926 9.99968 14.1667 10.3622 14.1667 13.223C14.1667 17.4481 6.9422 17.8115 5.9547 14.1663M10 9.99968L17.5 9.99967M10 9.99968L2.5 9.99967M5.83333 6.7764C5.83333 2.55128 13.0578 2.18783 14.0453 5.83301",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTextStrikethrough);
export default ForwardRef;
